export class ChangeReportEntryProps {
	contentLink: string;

	changedBy: string;

	changeDate: string;

	actionType: number;
}